import { get } from '@/lib/api/client'
import type {
    ApiResponse,
    PaginatedResponse,
} from '@/lib/api/types'

// Comment type (matching public app structure)
export interface Comment {
    id: string
    programmeId: string
    name: string
    email: string
    comment: string
    dateCommented: string
    replyCount?: number
}

export class ProgrammeCommentService {
    /**
     * Get paginated comments for a programme
     * GET /programme-comments/public/all/{programmeId}
     */
    async getComments(
        programmeId: string,
    ): Promise<ApiResponse<PaginatedResponse<Comment>>> {

        return await get<ApiResponse<PaginatedResponse<Comment>>>(
            `programme-comments/public/all/${programmeId}`
        )
    }
}

// Export singleton instance
export const programmeCommentService = new ProgrammeCommentService()

// Export default
export default programmeCommentService
